module.exports = __webpack_public_path__ + "img/user-guide-03-04.322d8952.png";